
import React from "react";
import { DataCustomField } from "../../models/customField.model";
import { CalendarIcon, ItemAddIconOutline } from "../common/Icons";

interface CardProps {
  formData: DataCustomField;
  handleClickDetail?: (code: string) => void;
}

const Card: React.FC<CardProps> = ({ formData, handleClickDetail }) => {
  return (
    <section className="card-element">
      <div className="card-item-row">
        <span>
          <p className="card-item-header">Nombre</p>
          <p className="card-item-value">{formData.hname}</p>
        </span>

        <span>
          <p className="card-item-header">Código</p>
          <p className="card-item-value">{formData.code}</p>
        </span>
      </div>

      <div className="card-item-row">
        <span>
          <p className="card-item-header">Tipo</p>
          <p className="card-item-value">{formData.type}</p>
        </span>
        <span>
          <p className="card-item-header">Valor por Defecto</p>
          <p className="card-item-value">{formData.default_value}</p>
        </span>
      </div>

      <div className="card-item-row">
        <span className="card-date-item">
          <CalendarIcon className="calendar-icon" />
          <p className="card-item-value">{formData.created_date}</p>
        </span>
      </div>

      <button className="card-element-plus-action" onClick={() => handleClickDetail && handleClickDetail(formData.code)}>
        <ItemAddIconOutline />
      </button>
    </section>
  );
}

export default Card;
